import script from "./projectSection.vue?vue&type=script&setup=true&lang=js"
export * from "./projectSection.vue?vue&type=script&setup=true&lang=js"

import "./projectSection.vue?vue&type=style&index=0&id=02bbf598&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02bbf598"]])

export default __exports__